import { Box, Spinner, getTokenCssVar } from '@vp/swan';
import styled from 'styled-components';
import { __ } from '@99designs/i18n';

const SpinnerArea = styled(Box)`
    flex: 1;
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${getTokenCssVar('SwanSemColorBgStrong')};
`;

export function ChatLoadingSpinner() {
    return (
        // Spinner requires accessibleText, but ChatStatusRegion already announces the
        // load, so the whole area is aria-hidden to stop the caption being read as a
        // near-duplicate of that announcement — same rule as the typing indicator.
        <SpinnerArea data-testid="chat-loading-spinner" aria-hidden="true">
            <Spinner accessibleText={__('Loading chat...')} />
        </SpinnerArea>
    );
}
